<template lang='pug' src='./hero.pug'></template>

<script>
import { scrollNav } from 'components/mixins'
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'

export default {
  props: ['props'],
  mixins: [scrollNav],
  components: {
    VueTrigger
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?39ff8c8f